export const SORT_ASC = "asc";
export const SORT_DESC = "desc";

export const compareAlphabetically = (a, b, direction = SORT_ASC) => {
  const result = String(a ?? "").localeCompare(String(b ?? ""), undefined, {
    numeric: true,
    sensitivity: "base",
  });
  return direction === SORT_DESC ? -result : result;
};

/**
 * Sort a list A–Z (or Z–A). getLabel may be a field name or a function.
 */
export const sortAlphabetically = (list, getLabel, direction = SORT_ASC) => {
  const items = Array.isArray(list) ? list : [];
  const labelOf =
    typeof getLabel === "function"
      ? getLabel
      : (item) =>
          item?.[getLabel] ??
          item?.name ??
          item?.label ??
          item?.store_name ??
          "";

  return [...items].sort((a, b) =>
    compareAlphabetically(labelOf(a), labelOf(b), direction)
  );
};
